<template>
  <div class="container event-expectations-images">
    <div
      v-for="item in expectations"
      class="event-expectations-images_item">
      <lazy-image
        :src="item.img_src"
        :lazy_src="item.lazy_img_src"
        class="event-expectations-images_item-img"
        :img_border_radius="img_bordered"
        cover_img
      />
      <div
        v-show="item.text"
        class="text-center">
        <span>
        {{item.text}}
        </span>
      </div>
    </div>
  </div>
</template>

<script>

import LazyImage from "../small_parts/LazyImage.vue";

export default {
  name: "EventExpectationsImages",
  components: {LazyImage},
  props: {
    /**props**/
    img_bordered: {
      type: Boolean,
      default: false,
      admin_type: 'checkbox',
    },
    expectations: {
      type: Array,
      default: () => [],
      admin_type: 'array',
      array_values: {
        img_src: {
          type: String,
          default: '/images/uploads-main-slide.jpeg',
          admin_type: 'image',
        },
        lazy_img_src: {
          type: String,
          default: '',
          admin_type: 'image',
        },
        text: {
          type: String,
          default: '',
          admin_type: 'textarea',
        },
      },
    },
    /**props**/
  },
}
</script>
